module.exports = __webpack_public_path__ + "img/u38.2875e75b.svg";